module.exports = __webpack_public_path__ + "img/video-white.1ecce0c5.svg";